import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_MATCH_BIOSEC_NIN_FETCH = 'TRN_MATCH_BIOSEC_NIN_FETCH'
export const TRN_MATCH_BIOSEC_NIN_FETCH_CANCELED = 'TRN_MATCH_BIOSEC_NIN_FETCH_CANCELED'
export const TRN_MATCH_BIOSEC_NIN_FETCH_ERROR = 'TRN_MATCH_BIOSEC_NIN_FETCH_ERROR'
export const TRN_MATCH_BIOSEC_NIN_FETCH_FULFILLED = 'TRN_MATCH_BIOSEC_NIN_FETCH_FULFILLED'

export const matchBiosecurityNINFetch = (matchId, nin) => ({
  notification: {
    id: TRN_MATCH_BIOSEC_NIN_FETCH,
    dismissAfter: 500,
    title: 'Buscando jugador...',
  },
  payload: { matchId, nin },
  type: TRN_MATCH_BIOSEC_NIN_FETCH,
})

export const matchBiosecurityNINFetchFulfilled = (payload) => ({
  notification: {
    id: TRN_MATCH_BIOSEC_NIN_FETCH,
    dismissAfter: 10,
    title: 'Jugador encontrado',
  },
  payload,
  type: TRN_MATCH_BIOSEC_NIN_FETCH_FULFILLED,
})

export const matchBiosecurityNINFetchCanceled = () => ({
  payload: null,
  type: TRN_MATCH_BIOSEC_NIN_FETCH_CANCELED,
})

export const matchBiosecurityNINFetchError = (payload) => ({
  payload,
  type: TRN_MATCH_BIOSEC_NIN_FETCH_ERROR,
})

export const matchBiosecurityNINFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_MATCH_BIOSEC_NIN_FETCH),
    mergeMap((action) =>
      epicServerRequest(
        'get',
        `${APP.api_url}/sports/soccer/match/${action.payload.matchId}/biosecurity/nin/${action.payload.nin}`,
        action,
      ).pipe(
        map(epicResponseHandler(matchBiosecurityNINFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_MATCH_BIOSEC_NIN_FETCH, TRN_MATCH_BIOSEC_NIN_FETCH_CANCELED))),
        catchError(epicErrorHandler(matchBiosecurityNINFetchError, action)),
      ),
    ),
  )
